export const benefits = [
  {
    icon: 'ri-time-line',
    title: 'Oszczędność czasu',
    description: 'Gotowe listy produktów zamiast godzin wyszukiwania na chińskich platformach. Wszystko co potrzebujesz w jednym miejscu.',
  },
  {
    icon: 'ri-star-line',
    title: 'Lepsze wybory',
    description: 'Porównuj produkty przed zakupem i wybieraj tylko sprawdzone okazje. Podejmuj świadome decyzje zakupowe.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Aktualne trendy',
    description: 'Znajduj najpopularniejsze produkty i bądź na bieżąco z najnowszymi trendami ze świata streetwear i mody.',
  },
];